//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Caprini',
  data () {
    return {
      form: {
        data0: '0',
        data1: '0',
        data2: '0',
        data3: '0',
        data4: '0',
        data5: '0',
        data6: '0',
        data7: '0',
        data8: '0',
        data9: '0',
        data10: '0',
        data11: '0',
        data12: '0',
        data13: '0',
        data14: '0',
        data15: '0',
        data16: '0',
        data17: '0',
        data18: '0',
        data19: '0',
        data20: '0',
        data21: '0',
        data22: '0',
        data23: '0',
        data24: '0',
        data25: '0',
        data26: '0',
        data27: '0',
        data28: '0',
        data29: '0',
        data30: '0',
        data31: '0',
        data32: '0',
        data33: '0',
        data34: '0',
        data35: '0'
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          console.log(key, 444)
          if (key) {
            form[key] = Number(form[key])
            let keyNumber = key.replace(/^data/, '')
            if (keyNumber <= 15) {
              result = result + form[key]
            } else if (form[key] && keyNumber > 15 && keyNumber <= 23) {
              result += 2
            } else if (form[key] && keyNumber > 23 && keyNumber <= 33) {
              result += 3
            } else if (form[key] && keyNumber > 33) {
              result += 5
            }
          }
        }
      }
      if (result <= 0) {
        self.descTxt = '非常低危；无预防措施时，VTE风险<0.5%'
      } else if (result > 1 && result <= 2) {
        self.descTxt = '低危；无预防措施时，VTE风险<1.5%'
      } else if (result > 2 && result <= 4) {
        self.descTxt = '中危；无预防措施时，VTE风险<3.0%'
      } else if (result > 4) {
        self.descTxt = '高危；无预防措施时，VTE风险6.0%'
      }
      return result.toString()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Caprini.vue